<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">充值记录</div>
    </div>

    <div class="detail_box">
      <van-empty v-if="listShow" :description="$t('item.noData')" />
      <table v-else>
        <tr>
          <th>金额</th>
          <th style="width: 20%">类型</th>
          <th>时间</th>
        </tr>
        <tr v-for="item in data">
          <td>{{ item.money }}</td>
          <td>{{ item.type == 1 ? '收入' : '支出' }}</td>
          <td>{{ item.time }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Fetch from '../../utils/fetch'
  import { DropdownMenu, DropdownItem } from 'vant'

  import { Empty } from 'vant'

  Vue.use(Empty)
  Vue.use(DropdownMenu).use(DropdownItem)

  export default {
    name: 'RechargeRecord',
    data() {
      return {
        lang: this.$i18n.locale || 'zh_cn',
        data: [],
        list: {},
        account: 0,
        option: [],
        listShow: false,
        funds: 0,
        userName: '',
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
    mounted() {
      document.getElementById('app').style.background =
        'linear-gradient(to bottom, #5674d3, #a8b6e5)'
      Fetch('/user/funds', {
        reason_id: 1,
      }).then((r) => {
        this.option.push({
          text: this.$t('moneybag.types'),
          value: 0,
        })

        this.showError(r.data.list.length)
        this.data = r.data.list
        this.funds = r.data.money
        this.userName = r.data.username
      })
    },
    methods: {
      chooseType(val) {
        if (val == 0) {
          Fetch('/user/funds').then((r) => {
            this.data = r.data.list
            this.showError(r.data.list.length)
          })
        } else {
          Fetch('/user/funds', {
            reason_id: val,
          }).then((r) => {
            this.data = r.data.list
            this.showError(r.data.list.length)
          })
        }
      },
      showError(len) {
        len == 0 ? (this.listShow = true) : (this.listShow = false)
      },
    },
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    // height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
  .user_yw {
    text-align: center;
    position: absolute;
    top: 74px;
    background: #ffffff;
    left: 15px;
    right: 15px;
    border-radius: 5px;
    padding: 15px;
    box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
    p:nth-child(1) {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }
    p:nth-child(2) {
      font-size: 24px;
      color: #ff5551;
      font-weight: bold;
    }
  }
  .user_zrzc {
    text-align: center;
    display: flex;
    justify-content: space-between;
    text-align: center;
    margin-top: 17px;
    span {
      width: 135px;

      color: #ffffff;
      margin: 0px 12px;
      padding: 10px;
      font-size: 12px;
      line-height: 15px;
      color: #fff;
      border-radius: 5px;
    }

    span:nth-child(1) {
      background: #ff5451;
    }

    span:nth-child(2) {
      background: #04c382;
    }
  }

  .detail_box {
    padding: 15px;
    background: rgba(255, 255, 255, 1);
    // margin-top: 224px;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 15px;
      border-bottom: 1px solid #ececec;

      .de_wrap {
        flex: 2;

        .tit {
          font-size: 12px;
          color: #333333;
          line-height: 18px;
          font-weight: bold;
        }

        .time {
          font-size: 12px;
          color: #999999;
          line-height: 18px;
        }
      }

      .price {
        flex: 1;
        font-size: 12px;
        line-height: 28px;
        font-weight: bold;
        text-align: right;
        color: #e82637;
        white-space: nowrap;
        &.del {
          color: #3faf3e;
        }
      }
    }

    table {
      width: 100%;
      tr {
        height: 50px;
        th {
          border: 1px solid #ebeef5;
          color: rgb(144, 147, 153);
        }
        td {
          line-height: 20px;
          border: 1px solid #ebeef5;
          text-align: center;
          color: rgb(96, 98, 102);
        }
      }
    }
  }
</style>
